import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { getSessionData } from '@confluence/session-data/entry-points/SessionData.ts';
import { getUserPermissionFromQuery } from '@confluence/external-collab-ui/entry-points/getUserPermissionFromQuery.ts';
import {
	GlobalOperationsUserPermissionTypeQuery,
	SitePermissionType,
} from '@confluence/external-collab-ui/entry-points/GlobalOperationsUserPermissionTypeQuery.ts';
import type { GlobalOperationsUserPermissionTypeQueryType as GlobalOperationsUserPermissionType } from '@confluence/external-collab-ui/entry-points/GlobalOperationsUserPermissionTypeQuery.ts';
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

export const getCanViewUserProfile = async (): Promise<boolean> => {
	await getSessionData();

	// External Collaborators should not have access to view user profile
	const { data: userPermissionData }: any = await queryInterop<GlobalOperationsUserPermissionType>({
		query: GlobalOperationsUserPermissionTypeQuery,
		errorPolicy: 'all',
	}).catch((error) => {
		getMonitoringClient().submitError(error, {
			attribution: Attribution.ADMIN_EXPERIENCE,
		});
		markErrorAsHandled(error);
		return new Error('PERMISSION ERROR');
	});

	const isExternalCollaborator =
		getUserPermissionFromQuery(userPermissionData) === SitePermissionType.EXTERNAL;

	return !isExternalCollaborator;
};
